import React, { useState, useEffect } from 'react';
import { HERO_SLIDES, HERO_CONTENT } from './Hero.js';
import './Hero.css';

const Hero = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % HERO_SLIDES.length);
    }, 5500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hs">
      <div className="hs__slides">
        {HERO_SLIDES.map((slide, index) => (
          <div
            key={slide.id}
            className={`hs__slide ${index === activeSlide ? 'is-active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          />
        ))}
        <div className="hs__overlay" />
      </div>

      <div className="hs__content">

        <h1 className="hs__heading" data-aos="fade-up" data-aos-delay="200">
          WE MANAGE<br />DESTINATION <br/> <span className="text-gradient">We Create MEMORIES</span>
        </h1>
        <p className="hs__subheading" data-aos="fade-up" data-aos-delay="300">
          {HERO_CONTENT.subheading}
        </p>
        <div className="hs__actions" data-aos="fade-up" data-aos-delay="400">
          <a href={HERO_CONTENT.ctaPrimary.path} className="rt__btn rt__btn-primary">
            {HERO_CONTENT.ctaPrimary.label}
          </a>

        </div>
      </div>

    </section>
  );
};

export default Hero;
